import isURL from 'validator/lib/isURL';

const commonTlds = [
  'com', 'net', 'org', 'io', 'co', 'app', 'es', 'dev', 'info',
  'biz', 'store', 'ai', 'me', 'tv', 'cc', 'pro', 'online',
  'site', 'tech', 'design', 'shop', 'mobi'
];

const commonCountries = [
  'ar', 'br', 'uy', 'cl', 'co', 'pe', 'mx', 've', 'ec', 'py', 'bo', 'do', 'cr', 'sv', 'gt'
]

const allExtensions = [...commonTlds, ...commonCountries];

export function validateUrlRaw(input) {
  if (!input || !input.trim()) {
    return { valid: false, error: 'La URL es requerida' };
  }

  let url = input.trim();
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }

  if (!isURL(url, {
    protocols: ['http', 'https'],
    require_protocol: true,
    require_valid_protocol: true,
    require_host: true,
    require_tld: true,
    allow_underscores: true,
    allow_trailing_dot: false,
    allow_protocol_relative_urls: false,
  })) {
    return { valid: false, error: 'Por favor ingresá una URL válida' };
  }

  let hostname;
  try {
    hostname = new URL(url).hostname;
  } catch {
    return { valid: false, error: 'Por favor ingresá una URL válida' };
  }

  const match = hostname.match(/\.(\w{2,})$/);
  const tld = match?.[1]?.toLowerCase();
  if (!tld || !allExtensions.includes(tld)) {
    return { valid: false, error: 'La URL debe tener una extensión válida como .com, .net, .org, etc.' };
  }

  return { valid: true, error: null };
}